<template>
	<content-view ref="CntView" :init="init" :end="end" :qnt="mapOs.length">
		<template v-for="(item, index) in mapOs">
			<description-os :data="item" slot="osNames" />

			<grafic-os :data="item" slot="osTimeLine" :init="init.time" />
		</template>
	</content-view>
</template>
<script>
	import ContentView from './content-view.vue';
	import DescriptionOs from './description-os.vue';
	import GraficOs from './grafic-os.vue';
	import { timeNomalize } from './tools.js';

	export default {
		components: {
			ContentView,
			DescriptionOs,
			GraficOs,
		},
		data() {
			return {
				mapOs: [],

				init: {
					time: 9e99,
					sDate: null,
				},
				end: {
					time: 0,
					sDate: null,
				},
			};
		},
		methods: {
			CalculateInitEndGrid(item) {
				const osInit = timeNomalize(item.rInit || item.pInit);
				const osEnd = timeNomalize(item.rTerm || item.pTerm);

				if (this.init.time > osInit || this.init.time > osEnd) {
					const sDate =
						this.init.time > osInit
							? item.rInit || item.pInit
							: item.rTerm || item.pTerm;

					this.init = {
						time: timeNomalize(`${sDate.split(' ')[0]} 00:00:00`),
						sDate: sDate,
					};
				}

				if (this.end.time < osInit || this.end.time < osEnd) {
					const sDate =
						this.end.time < osInit
							? item.rInit || item.pInit
							: item.rTerm || item.pTerm;

					let end = sDate.split(' ')[0].split('-');
					end[2] =
						parseInt(end[2]) + 1 < 9
							? `0${parseInt(end[2]) + 1}`
							: parseInt(end[2]) + 1;

					this.end = {
						time: timeNomalize(`${end.join('-')} 00:00:00`),
						sDate: sDate,
					};
				}
			},

			mountItem(item) {
				let pushItem = {};

				pushItem.cod = item.cod;
				pushItem.label = item.label;

				pushItem.xDate = {
					pInit: item.pInit,
					rInit: item.rInit,
					pTerm: item.pTerm,
					rTerm: item.rTerm,
				};

				pushItem.date = {
					pInit: timeNomalize(item.pInit),
					rInit: item.rInit == null ? null : timeNomalize(item.rInit),
					pTerm: timeNomalize(item.pTerm),
					rTerm: item.rTerm == null ? null : timeNomalize(item.rTerm),
				};

				this.mapOs.push(pushItem);
			},

			update() {
				if (this.$slots.default == undefined) return;

				this.mapOs = [];

				this.$slots.default.forEach((component) => {
					let item = JSON.parse(
						JSON.stringify(component.componentOptions.propsData)
					);

					this.CalculateInitEndGrid(item);

					this.mountItem(item);
				});

				setTimeout((e) => {
					this.$refs.CntView.update();
				}, 50);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/GraficMode/components/container-os.vue